import React from 'react';
import PropTypes from 'prop-types';
import { isBoolean } from 'lodash';
import { ItemLabelWraper, ItemValueWrapper } from '../styled';

const getYesNo = (itemValue) => (itemValue ? 'Yes' : 'No');

const YesNo = ({ itemLabel, itemValue = '-' }) => {
  const value = isBoolean(itemValue) ? getYesNo(itemValue) : itemValue;

  return (
    <>
      <ItemLabelWraper span="12">{itemLabel}</ItemLabelWraper>
      <ItemValueWrapper span="12">{value}</ItemValueWrapper>
    </>
  );
};

YesNo.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default YesNo;
